"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GetCelloTokenResponse", {
    enumerable: true,
    get: function() {
        return GetCelloTokenResponse;
    }
});
const _zod = require("zod");
const GetCelloTokenResponse = _zod.z.object({
    productId: _zod.z.string(),
    token: _zod.z.string(),
    userDetails: _zod.z.object({
        firstName: _zod.z.string(),
        lastName: _zod.z.string(),
        fullName: _zod.z.string(),
        email: _zod.z.string()
    })
});
